import { environment } from './../../../environments/environment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from  'rxjs';
import { catchError, tap } from 'rxjs/operators';

var apiRequests = `${environment.BACKEND_URL}/HS_Usuario`;

@Injectable({
  providedIn: 'root'
})
export class UserService {
 
  constructor(
    private http: HttpClient,
  ) {
     
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      console.log(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

  httpHeader = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': "Basic "+btoa(localStorage.getItem('token_jwt')),
    }),
  };
 
  getPersonal(): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(localStorage.getItem('token_jwt')));
    return this.http.get(apiRequests+'/datosPersonales', {headers: headers})
      .pipe(
          catchError(this.handleError(''))
      );
  }

  getById(id): Observable<any>{
    return this.http.get(apiRequests+'/'+id)
      .pipe(
          catchError(this.handleError(''))
      );
  }
  
  insert_ext(correo, contrasena, nombres, apellidos, celular, estado, id_area, rol, capacity_hours, tk): Observable<any>{
    let headers = new HttpHeaders();
    headers = headers.set('Content-type', 'application/json');
    headers = headers.set('Authorization', 'Basic ' + btoa(tk));

  let data = {
    correo: correo,
    contrasena: contrasena,
    nombres: nombres,
    apellidos: apellidos,
    celular: celular,
    estado: estado,
    id_area: id_area,
    rol: rol,
    capacity_hours: capacity_hours,
  }
  
  return this.http.post(apiRequests+'/externo', data, { headers: headers } )
    .pipe(
        catchError(this.handleError(''))
    );
  }

  sendMessage(solicitudId, destination, type, asunto, mensaje): Observable<any>{

    let data = {
      destination: destination,
      type: type,
      asunto: asunto,
      idref: {},
      mensaje: mensaje,
    }
    
    return this.http.post(apiRequests+'/tksolicitud/'+solicitudId, data)
      .pipe(
          catchError(this.handleError(''))
      );
  }

  sendMessageApprove(solicitudId, destination, type, asunto, mensaje, no_files_validation: boolean): Observable<any>{

    let data = {
      destination: destination,
      type: type,
      asunto: asunto,
      idref: {},
      mensaje: mensaje,
      no_files_validation
    }
    
    return this.http.post(apiRequests+'/approve/'+solicitudId, data)
  }

  sendMessagePayout(destination, type, asunto, mensaje): Observable<any>{

    let data = {
      destination: destination,
      type: type,
      asunto: asunto,
      idref: {},
      mensaje: mensaje,
    }
    
    return this.http.post(`${environment.BACKEND_URL}/solicitud/payout`, data)
      .pipe(
          catchError(this.handleError(''))
      );
  }
   
  
  getMyRol(){
    return this.http.get(`${environment.BACKEND_URL}/my-rol`, this.httpHeader);
  }
  
}